/**
 * Patient document scanning (NAPS2 / ISAMED Scanner Service).
 */
export interface ScannerDriverLinks {
    hp: string;
    canon: string;
    epson: string;
    brother: string;
    ricoh: string;
    xerox: string;
    kodak: string;
}

export const DEFAULT_SCANNER_DRIVER_LINKS: ScannerDriverLinks = {
    hp: 'https://support.hp.com/drivers',
    canon: 'https://www.usa.canon.com/support',
    epson: 'https://epson.com/Support/sl/s',
    brother: 'https://support.brother.com',
    ricoh: 'https://www.pfu.ricoh.com/global/scanners/support/',
    xerox: 'https://www.support.xerox.com',
    kodak: 'https://www.alarisworld.com/en-us/solutions/document-scanners/support'
};

/** Scanner-service installers hosted on isamed.ai/uploads (no trailing slash). */
export const SCANNER_INSTALLER_UPLOADS_BASE = 'https://stag-isamed.mobiloitte.io/api/v1';

export const SCANNER_INSTALLER_FILES = {
    win: 'ISAMED-Scanner-Service-Setup.exe',
    mac: 'scanner-service-macos.dmg'
} as const;

export type ScannerInstallerPlatform = keyof typeof SCANNER_INSTALLER_FILES;

/** Build full download URL for Windows (.exe) or macOS (.dmg). */
export function buildScannerInstallerUrl(platform: ScannerInstallerPlatform): string {
    const file = SCANNER_INSTALLER_FILES[platform];
    return `${SCANNER_INSTALLER_UPLOADS_BASE}/${file}`;
}

/** Default production installer URLs (used by environment.prod.ts). */
export const DEFAULT_SCANNER_INSTALLER_URLS = {
    win: buildScannerInstallerUrl('win'),
    mac: buildScannerInstallerUrl('mac')
} as const;

export interface AppScannerEnvironment {
    enabled: boolean;
    /** Direct health endpoint (overrides naps2 host/port when set). */
    healthUrl?: string;
    /** ESCL base URL for documentation; runtime uses naps2.esclHost + ports. */
    esclUrl?: string;
    useDevProxy?: boolean;
    installerUrlWin?: string;
    installerUrlMac?: string;
    /** When set, "Browse / Install Scanner Driver" opens this URL (model-specific driver page). */
    scannerDriverHelpUrl?: string;
    scannerDriverLinks?: ScannerDriverLinks;
    naps2?: {
        esclHost?: string;
        esclPorts?: number[];
        healthPort?: number;
        useDevProxy?: boolean;
        healthProxyPath?: string;
        esclProxyPath?: string;
    };
    /** Optional browser webcam/UVC scan (not hardware scanner). */
    webcamScanEnabled?: boolean;
}
